import axios from 'axios';
import API_BASE_URL from '../config';
import { getAccessToken } from '../utils/auth';

const authAxios = axios.create({
  baseURL: API_BASE_URL,
});

authAxios.interceptors.request.use((config) => {
  const token = getAccessToken();
  console.log("🛂 Attaching token:", token); // <-- Add this

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    console.warn("⚠️ No access token found!");
  }

  return config;
});


export const fetchPaginatedData = async (
  prefix,
  endpoint,
  page = 0,
  size = 50,
  filterQuery = '',
  searchTerm = ''
) => {
  const params = { page, size };

  if (filterQuery.trim()) {
    params.query = filterQuery.trim(); // sent as `query`
  }

  if (searchTerm.trim()) {
    params.search = searchTerm.trim(); // sent as `search`
  }

  const response = await authAxios.get(`${prefix}/admin/${endpoint}`, {
    params,
  });

  return response.data;
};




export const login = async (username, password) => {
  const response = await axios.post(`${API_BASE_URL}/user/login`, {
    username,
    password,
  });
  return response.data;
};


export const addLocationOption = async (locationName) => {
  try {
    const response = await authAxios.post(`/option/location`, {
      locationName,
    });
    return response.data; // Assuming this returns the ID or success message
  } catch (error) {
    console.error("❌ Failed to add location option:", error);
    throw error;
  }
};

export const addTableRow = async (prefix, addEndpoint, data) => {
  try {
    const response = await authAxios.post(`/${prefix}/${addEndpoint}`, data);
    return response.data;
  } catch (error) {
    console.error(`❌ Failed to add to ${addEndpoint}:`, error);
    throw error;
  }
};

export const deleteTableRow = async (prefix, deleteEndpoint, id) => {
  try {
    await authAxios.delete(`/${prefix}/${deleteEndpoint}/${id}`);
  } catch (error) {
    console.error(`❌ Failed to delete row ${id} from ${deleteEndpoint}`, error);
    throw error;
  }
};

